import { gql } from "@apollo/client";

export const GET_ENVIO_INSUMOS_DISPONIBLES = gql`
  query GetEnvioInsumosDisponibles($idEvaluacion: Int!) {
    envioInsumosDisponibles(idEvaluacion: $idEvaluacion) {
      idInsumoN
      idInsumo
      descripcion
      tipoInsumo
      eleccion
      unidad
    }
  }
`;